module["exports"] = [
  ""
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/state.js
// module id = 1002
// module chunks = 0